export default "__VITE_ASSET__dfQDCiox__"